import React, { useContext, useEffect, useState, useRef } from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import parse from 'html-react-parser'
import objectPath from 'object-path'
import { getDatasourceValue } from 'designer/component/action/Data'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import { Badge } from 'reactour'

const RichTextPreview = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const { uischema, config } = props
  const { isDynamic = false, dynamicName = '', dynamicIndex = 0 } = config
  let { key, pattern = '' } = uischema
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let designerJsonName = objectPath.get(jsonForm, `jsonName`) || {}
  let designerSubUi = objectPath.get(jsonForm, `isSubUi`) || {}
  const { formatDate, formatTime, formatDateTime } = useTimeFormat()

  const [datasource, setDatasource] = useState([])
  const richtextRef = useRef(null)

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      richtextRef?.current?.offsetWidth,
    )

    useEffect(() => {
      const handleResize = () => {
        setWindowDimensions(richtextRef?.current?.offsetWidth)
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    if (windowDimensions) {
      return windowDimensions
    }
    if (richtextRef?.current?.offsetWidth) {
      return richtextRef?.current?.offsetWidth
    }
    return 0
  }

  const tableWidth = useWindowDimensions()

  const isHTML = (str) => {
    const doc = new DOMParser().parseFromString(str, 'text/html')
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1)
  }

  const options = {
    replace: (item) => {
      let { name, children, parent } = item
      if (name === 'code' && children[0]) {
        let found = datasource.find(
          (item) => `@${item.name}` === children[0].data,
        )

        if (found) {
          let dataValue = ''
          let { name, key, dataType, sourceKey } = found
          if (dataType === 'jsonData') {
            let styleText = parent?.attribs?.style || ''
            let style = styleText.replace(' ', '')
            let styleSplit = style.split(';').map((item) => item.trim())
            let findWidth = styleSplit.find((item) => item.startsWith('width'))
            let widthPercent = findWidth
              ? findWidth.split(':').pop().replace('%', '')
              : '100%'
            let columnWidth = (tableWidth * Number(widthPercent)) / 100
            let formValue = null
            if (isDynamic) {
              formValue = objectPath.get(
                jsonForm,
                `formData.${dynamicName}.${dynamicIndex}.${name}`,
              )
            } else {
              formValue = objectPath.get(jsonForm, `formData.${name}`)
            }
            if (
              typeof formValue === 'object' &&
              Object.keys(formValue).length >= 0
            ) {
              let keyList = Object.keys(formValue)
              return (
                <div>
                  {keyList.map((key, index) => {
                    let jsonName = objectPath.get(designerJsonName, key) || key
                    let isSubUi = objectPath.get(designerSubUi, key) || null
                    let value = key ? objectPath.get(formValue, key) : null
                    if (Array.isArray(value) && value.length > 0) {
                      let column = Object.keys(value[0])
                      let table = value
                      return (
                        <Row className="d-flex">
                          <Col sm="auto" className="pr-0">
                            {jsonName}
                          </Col>
                          <Col sm="auto" className="px-0 mx-2">
                            :
                          </Col>
                          <Col className="px-0">
                            <div
                              key={`${key}-${index}`}
                              style={{
                                maxWidth: columnWidth ?? '100%',
                                overflowX: 'auto',
                              }}
                            >
                              <table
                                border="1"
                                style={{ borderColor: '#e3e3e3' }}
                                className="w-100"
                              >
                                <thead>
                                  <tr>
                                    {column.map((name) => {
                                      if (name === 'tableData') return ''
                                      return (
                                        <th
                                          className="p-2"
                                          style={{ minWidth: '150px' }}
                                        >
                                          {name}
                                        </th>
                                      )
                                    })}
                                  </tr>
                                </thead>
                                <tbody>
                                  {table.map((item) => (
                                    <tr>
                                      {column.map((name) => {
                                        let value = objectPath.get(item, name)
                                        if (name === 'tableData') return ''
                                        if (
                                          typeof value === 'object' &&
                                          Object.keys(value).length > 0
                                        ) {
                                          return JSON.stringify(value, null, 2)
                                        }
                                        return (
                                          <td
                                            className="p-2"
                                            style={{ minWidth: '150px' }}
                                          >
                                            {value}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      )
                    }
                    if (typeof value === 'boolean') {
                      return (
                        <Row className="d-flex">
                          <Col sm="auto" className="pr-0">
                            {jsonName}
                          </Col>
                          <Col sm="auto" className="px-0 mx-2">
                            :
                          </Col>
                          <Col className="px-0">
                            <Form.Control
                              style={{ width: '18px', height: '18px' }}
                              type="checkbox"
                              name={key}
                              id={key}
                              checked={value}
                            />
                          </Col>
                        </Row>
                      )
                    }
                    if (
                      typeof value === 'object' &&
                      value &&
                      Object.keys(value).length > 0
                    ) {
                      return JSON.stringify(value, null, 2)
                    }
                    return (
                      <Row className="d-flex">
                        <Col sm="auto" className="pr-0">
                          {jsonName}
                        </Col>
                        <Col sm="auto" className="px-0 mx-2">
                          :
                        </Col>
                        <Col className="px-0">{value}</Col>
                      </Row>
                    )
                  })}
                </div>
              )
            }
            return <>{formValue}</>
          } else if (dataType === 'datasource') {
            let { isGroup = false, subDatasource = [], type } = found

            if (isGroup) {
              let hasValue = subDatasource.filter((item) => {
                let key = item.value ? `${sourceKey}.${item.value}` : sourceKey
                let dataValue = getDatasourceValue({
                  item: item,
                  key: key,
                  datasourceValue,
                  formatDate,
                  formatTime,
                  formatDateTime,
                  isGroup,
                })
                return dataValue
              })

              let option = {
                replace: (replaceItem) => {
                  let { name, children } = replaceItem
                  if (name === 'code' && children && children[0]?.data) {
                    let item = subDatasource.find(
                      ({ name }) => children[0].data === `@${name}`,
                    )

                    let dataValue = ''
                    if (item) {
                      let key = item.value
                        ? `${sourceKey}.${item.value}`
                        : sourceKey

                      dataValue = getDatasourceValue({
                        item: item,
                        key: key,
                        datasourceValue,
                        formatDate,
                        formatTime,
                        formatDateTime,
                        isGroup,
                      })

                      if (dataValue) {
                        if (isHTML(dataValue)) {
                          return parse(dataValue)
                        }
                        if (item.pattern) {
                          let replaceOption = {
                            replace: (replaceItem) => {
                              let { name, children } = replaceItem
                              if (
                                name === 'code' &&
                                children &&
                                children[0]?.data
                              ) {
                                return <span>{dataValue}</span>
                              }
                            },
                          }
                          return (
                            <label className="code-value">
                              {parse(item.pattern, replaceOption)}
                            </label>
                          )
                        }
                        return <span>{dataValue}</span>
                      }
                      return <></>
                    } else {
                      dataValue = getDatasourceValue({
                        item: found,
                        key: `${sourceKey}.${found.value}`,
                        datasourceValue,
                        formatDate,
                        formatTime,
                        formatDateTime,
                        isGroup,
                      })

                      let replaceOption = {
                        replace: (replaceItem) => {
                          let { name, children } = replaceItem
                          if (
                            name === 'code' &&
                            children &&
                            children[0]?.data
                          ) {
                            if (dataValue) {
                              return <>{dataValue}</>
                            }
                          }
                        },
                      }
                      dataValue = parse(found.pattern, replaceOption)
                    }
                    return dataValue
                  }
                },
              }
              let parseValue =
                hasValue.length > 0 ? parse(found.pattern, option) : ''
              return <>{parseValue}</>
            } else {
              let value = getDatasourceValue({
                item: found,
                key: `${sourceKey}.${found.value}`,
                datasourceValue,
                formatDate,
                formatTime,
                formatDateTime,
              })

              if (type === 'badge' && value) {
                let { badgeColor, badgeTextColor } = found
                return (
                  <Badge
                    style={{
                      backgroundColor: badgeColor,
                      boxShadow: 'unset',
                      position: 'relative',
                      borderRadius: '4px',
                    }}
                    className='py-1'
                  >
                    <span style={{ color: badgeTextColor }}>{value}</span>
                  </Badge>
                )
              }
              return <div>{value}</div>
            }
          } else if (dataType === 'today') {
            dataValue = getDatasourceValue({
              item: found,
              key: ``,
              datasourceValue,
              formatDate,
              formatTime,
              formatDateTime,
              isGroup: true,
            })
          } else if (dataType === 'input') {
            let { isDynamic = false, dynamicData } = config
            let formValue
            if (isDynamic) {
              formValue = objectPath.get(dynamicData, found.name) || ''
            } else {
              formValue = objectPath.get(jsonForm, `formData.${key}`) || ''
            }
            dataValue = getDatasourceValue({
              item: found,
              key: ``,
              formValue,
              formatDate,
              formatTime,
              formatDateTime,
              isGroup: true,
            })
          } else if (dataType === 'dynamicData') {
            let dataKey = `${dynamicName}.${dynamicIndex}.${name}`
            dataValue = objectPath.get(jsonForm.formData, dataKey)
          }
          if (dataValue && found.pattern) {
            if (isHTML(dataValue)) {
              return parse(dataValue)
            }
            let replaceOption = {
              replace: (replaceItem) => {
                let { name, children } = replaceItem
                if (name === 'code' && children && children[0]?.data) {
                  if (Array.isArray(dataValue)) {
                    let keylist = Object.keys(dataValue[0])
                    return (
                      <>
                        {dataValue.map((item) => {
                          return (
                            <>
                              <hr />
                              {keylist.map((key) => {
                                let value = objectPath.get(item, key)
                                return (
                                  <Row className="d-flex w-100">
                                    <Col sm="auto" className="pr-0">
                                      {key}
                                    </Col>
                                    <Col sm="auto" className="px-0 mx-2">
                                      :
                                    </Col>
                                    <Col className="px-0">{value}</Col>
                                  </Row>
                                )
                              })}
                            </>
                          )
                        })}
                      </>
                    )
                  }
                  if (
                    typeof dataValue === 'object' &&
                    Object.keys(dataValue).length > 0
                  ) {
                    return (
                      <div>
                        {Object.keys(dataValue).map((key) => {
                          let value = objectPath.get(dataValue, key)
                          return (
                            <Row className="d-flex">
                              <Col sm="auto" className="pr-0">
                                {key}
                              </Col>
                              <Col sm="auto" className="px-0 mx-2">
                                :
                              </Col>
                              <Col className="px-0">{value}</Col>
                            </Row>
                          )
                        })}
                      </div>
                    )
                  }
                  return <>{dataValue}</>
                }
              },
            }
            let parseValue = parse(found.pattern, replaceOption)
            return <label className="code-value">{parseValue}</label>
          }
          return <></>
        }
      }
    },
  }

  useEffect(() => {
    if (uischema?.datasource) {
      setDatasource(uischema.datasource)
    }
  }, [])
  const isCustomLabelWidth = uischema?.labelWidth === 'custom'
  const labelWidthStyle =
    isCustomLabelWidth && uischema?.labelCustomWidth
      ? {
          flex: `0 0 ${uischema.labelCustomWidth}`,
          maxWidth: uischema.labelCustomWidth,
          width: uischema.labelCustomWidth,
        }
      : {}

  return (
    <Form.Group className="mb-0" controlId={uischema?.controlId}>
      <Row className="w-100 mx-0">
        {uischema?.label && (
          <Col
            className="mt-2"
            sm={isCustomLabelWidth ? 'auto' : uischema?.labelWidth}
            style={{
              ...labelWidthStyle,
              padding: uischema?.labelPadding ?? '',
              margin: uischema?.labelMargin ?? '',
            }}
          >
            <Form.Label
              className={`m-0 w-100 ${
                uischema?.textAlign ? 'text-' + uischema?.textAlign : ''
              }`}
            >
              {uischema?.label}{' '}
              {uischema?.require && <span className="text-danger">*</span>}
            </Form.Label>
          </Col>
        )}
        <Col
          className="richtext-custom"
          sm={uischema?.elementWidth}
          ref={richtextRef}
        >
          {parse(pattern, options)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default RichTextPreview
